import { useEffect, useState } from "react";

// Mismo punto de corte que ya usa el resto del panel para pasar a layout de móvil (el prefijo
// "sm:" de Tailwind, 640px) — así que lo que aquí se considera "móvil" es justo lo que ya se ve
// apilado en una columna en vez de lado a lado.
const MOBILE_BREAKPOINT_PX = 640;

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_BREAKPOINT_PX);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
